import routes from "./routes";

/**
 * Pages shown without asking for consent first. Only the public plan (#3075):
 * it is read-only, stores nothing about the visitor beyond the display
 * language (i18next's `i18nextLng`, technically necessary; there is no
 * tracking, and Google Maps loads only after consent), and sits in an iframe on
 * the tenant's website, where storage is partitioned — a consent given in the
 * app does not reach it, so every website visitor would face the consent page
 * inside the frame. Booking from it opens the full app in a new window, which
 * asks as usual (PO, 2026-10-18).
 */
export const isConsentExemptPath = (pathname: string): boolean => {
  // As the router matches it: any case, with or without a trailing slash.
  let path = pathname.toLowerCase();
  while (path.length > 1 && path.endsWith("/")) path = path.slice(0, -1);
  return path === routes.publicPlanPath;
};

/**
 * Whether the consent page must come first on this path — the one condition
 * both consent checks in `PageRoutes.tsx` (the redirect and the render gate)
 * ask, so the exemption cannot reach one and miss the other.
 */
export const consentRequiredFirst = (input: {
  consent: unknown;
  consentRequired: boolean | undefined;
  pathname: string;
}): boolean =>
  input.consent === null &&
  input.consentRequired === true &&
  !isConsentExemptPath(input.pathname);
